const defaultFlags = {
    education: false,
    'page-load-metrics': false,
    'service-worker-caching': false,
    'mandatory-email-verification': false,
    'hubspot-chat-support': false,
    'workspace-members-filter': false,
    'report-subscriptions-to-sentry': false,
    'public-api-manage-personal-tokens': false,
    'cwv-custom-grid': false,
    'restricted-uploads': false,
    'design-systems': false,
    'design-systems-editor': false,
    'components-description': false,
    'component-ingest-on-demand': false,
    'set-as-template': false,
    'guests-in-project': false,
    profiles: false,
    'profile-document-detail-view': false,
    'community-canvas': false,
    'publish-community': false,
    'dark-mode-toggle': false,
    'scim-access': false,
    'pages-unread-annotations': false,
    sidebar: false,
    'multiple-authorizations': false,
    'collections-select-all-documents': false,
    'sign-up-path-chooser': false,
    'onboarding-empty-states': false,
    'automated-feature-provisioning': false,
    /**
     * Escape hatch allowing to not request Customer.billing
     * https://github.com/sketch-hq/Cloud/issues/16798
     */
    'workspaces-dropdown-trial-pill': false,
    // these flags are used when user is not even signed in
    // it is expected that these flags will be changed
    // using DevTools
    'new-sharing': false,
    'annotations-summary': false,
    'prices-updated': false,
    'publication-hearts': false,
    'search-filter-sort': false,
    'convert-monthly-to-yearly': false,
    'troubleshooting-consent': false,
    'web-renderer-marina-inspector': false,
    'export-design-tokens': false,
    'proj-education-renewal': false,
};

export { defaultFlags };
